import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import "./ShowcaseAlt.css";

const images = ["CallPopUp.jpg", "CallToLB3.jpg", "ECR.jpg"];

const ShowcaseAlt = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, 4000);

      return () => clearInterval(timer);
    }
  }, [isHovered]);

  return (
    <section className="showcase-alt">
      <div className="showcase-alt-text" ref={ref}>
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h2>Seamless Communication</h2>
          <p>
            Connect instantly with any station across the vessel through our
            integrated video call system. Experience crystal-clear communication
            that ensures safety and efficiency during critical operations.
          </p>
          <div className="feature-bullets">
            <motion.ul
              initial={{ opacity: 0, x: 100 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              <li>Real-time video connectivity</li>
              <li>Multi-station communication</li>
              <li>Emergency priority calls</li>
            </motion.ul>
          </div>
        </motion.div>
      </div>
      <div className="carousel-container-alt">
        <motion.div
          className="carousel-alt"
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
        >
          <AnimatePresence mode="wait">
            <motion.img
              key={currentImageIndex}
              src={require(`../components/Imgs/${images[currentImageIndex]}`)}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
            />
          </AnimatePresence>
          <div className="dots-alt">
            {images.map((_, index) => (
              <motion.div
                key={index}
                className={`dot-alt ${
                  index === currentImageIndex ? "active" : ""
                }`}
                onClick={() => setCurrentImageIndex(index)}
                whileHover={{ scale: 1.2 }}
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ShowcaseAlt;
